import { combineReducers } from 'redux';
import auth from './auth';
import app from './app';
import ecosystem from './ecosystem';
const rootReducer = combineReducers({
  auth,
  app,
  ecosystem
});
export default rootReducer;